import {useCallback} from "react";
import lscache from "lscache";

import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import type {HomeMatchConfigurationSourceSection} from "@pg-rp/common-types";

import {useRefererData} from "../../../hooks/use_referer_data";
import {getSiteSource} from "../../../hooks/use_site_source";
import {useAppDispatch} from "../../../store/hooks/use_app_dispatch";
import {kmApi} from "../../km_app/api/km_api";
import {PHONE_VERIFICATION_MODAL_DISMISSED} from "../../km_app/constants/storage_keys";
import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import {usePatchUserHomeMatchPreferencesMutation, usePatchUserPreferencesMutation, usePutUserHomeMatchPreferencesMutation} from "../api/user_api";
import {MarketingConsentType} from "../constants/user_consents";
import {HOME_MATCH_SERVICE_NOTIFICATION_CONTENT} from "../constants/user_content";
import {createDefaultHmActivationIntent, createHmActivationPendingAction} from "../phone_verification/types/phone_verification_types";
import {requestPhoneVerification} from "../state/user_phone_verification_slice";

interface ISwitchHomeMatchPreferencesOptions {
    /** Called instead of opening phone verification when `skipPhoneVerificationPrompt` is set and the API still requires a verified phone. */
    onPhoneVerificationRequired?: () => void;
    showSuccessNotification?: boolean;
    syncCplPreferences?: boolean;
    sourceSection?: HomeMatchConfigurationSourceSection;
    /**
     * When true, do not open phone verification again on "zweryfikuj numer" errors.
     * Used by the post-SMS action executor - verification already succeeded.
     */
    skipPhoneVerificationPrompt?: boolean;
}

export const useHomeMatchPreferences = () => {
    const {ENABLED, DISABLED} = HOME_MATCH_SERVICE_NOTIFICATION_CONTENT;

    const [patchHomeMatchPreferences, {isLoading: isHomeMatchPreferencesLoading}] = usePatchUserHomeMatchPreferencesMutation();
    const [putHomeMatchPreferences, {isLoading: isHomeMatchConfigurationLoading}] = usePutUserHomeMatchPreferencesMutation();
    const [patchUserPreferences, {isLoading: isUserPreferencesLoading}] = usePatchUserPreferencesMutation();
    const dispatch = useAppDispatch();
    const siteSource = getSiteSource(useRefererData().slug);

    const switchHomeMatchPreferences = useCallback(
        async (checked: boolean, options: ISwitchHomeMatchPreferencesOptions = {}) => {
            const {
                onPhoneVerificationRequired,
                showSuccessNotification = true,
                syncCplPreferences = true,
                sourceSection,
                skipPhoneVerificationPrompt = false
            } = options;

            try {
                if (sourceSection) {
                    await putHomeMatchPreferences({
                        is_active: checked,
                        source_section: sourceSection
                    }).unwrap();
                } else {
                    await patchHomeMatchPreferences({
                        is_active: checked,
                        update_source: siteSource
                    }).unwrap();
                }

                if (syncCplPreferences) {
                    await patchUserPreferences({
                        [MarketingConsentType.CPL]: checked,
                        update_source: siteSource
                    }).unwrap();
                }

                dispatch(kmApi.util.invalidateTags(["PreleadList"]));

                if (checked || showSuccessNotification) {
                    dispatch(
                        addNotification({
                            type: "success",
                            content: checked ? ENABLED : DISABLED
                        })
                    );
                }

                return true;
            } catch (error) {
                const kmAppError = error as {status?: number; data?: {is_active: string[]}};

                if (checked && isHomeMatchPhoneVerificationRequiredError(kmAppError)) {
                    if (skipPhoneVerificationPrompt) {
                        onPhoneVerificationRequired?.();
                    } else {
                        lscache.remove(PHONE_VERIFICATION_MODAL_DISMISSED);
                        dispatch(
                            requestPhoneVerification({
                                pendingAction: createHmActivationPendingAction(createDefaultHmActivationIntent({syncCplPreferences, sourceSection})),
                                awaitCompletion: true
                            })
                        );
                    }
                } else if (kmAppError?.status === 400 && kmAppError?.data?.is_active) {
                    dispatch(
                        addNotification({
                            type: "failure",
                            content: kmAppError.data.is_active.join(", ")
                        })
                    );
                } else {
                    notifyBugsnagClient(
                        error instanceof Error
                            ? error
                            : {
                                  message: JSON.stringify(error)
                              },
                        "Failed to update HomeMatch and CPL preferences"
                    );
                    dispatch(addNotification(defaultAPIErrorNotification));
                }

                return false;
            }
        },
        [DISABLED, ENABLED, dispatch, patchHomeMatchPreferences, patchUserPreferences, putHomeMatchPreferences, siteSource]
    );

    return {
        isSwitchingHomeMatchPreferences: isHomeMatchPreferencesLoading || isHomeMatchConfigurationLoading || isUserPreferencesLoading,
        switchHomeMatchPreferences
    };
};

const isHomeMatchPhoneVerificationRequiredError = (error: {status?: number; data?: {is_active: string[]}}) => {
    return (
        error?.status === 400 &&
        Array.isArray(error?.data?.is_active) &&
        error.data.is_active.some((message) => message.toLowerCase().includes("zweryfikuj numer telefonu"))
    );
};
import {useCallback} from "react";
import lscache from "lscache";

import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import type {HomeMatchConfigurationSourceSection} from "@pg-rp/common-types";

import {useRefererData} from "../../../hooks/use_referer_data";
import {getSiteSource} from "../../../hooks/use_site_source";
import {useAppDispatch} from "../../../store/hooks/use_app_dispatch";
import {kmApi} from "../../km_app/api/km_api";
import {PHONE_VERIFICATION_MODAL_DISMISSED} from "../../km_app/constants/storage_keys";
import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import {usePatchUserHomeMatchPreferencesMutation, usePatchUserPreferencesMutation, usePutUserHomeMatchPreferencesMutation} from "../api/user_api";
import {MarketingConsentType} from "../constants/user_consents";
import {HOME_MATCH_SERVICE_NOTIFICATION_CONTENT} from "../constants/user_content";
import {createDefaultHmActivationIntent, createHmActivationPendingAction} from "../phone_verification/types/phone_verification_types";
import {requestPhoneVerification} from "../state/user_phone_verification_slice";

interface ISwitchHomeMatchPreferencesOptions {
    /** Called instead of opening phone verification when `skipPhoneVerificationPrompt` is set and the API still requires a verified phone. */
    onPhoneVerificationRequired?: () => void;
    showSuccessNotification?: boolean;
    syncCplPreferences?: boolean;
    sourceSection?: HomeMatchConfigurationSourceSection;
    /**
     * When true, do not open phone verification again on "zweryfikuj numer" errors.
     * Used by the post-SMS action executor - verification already succeeded.
     */
    skipPhoneVerificationPrompt?: boolean;
}

export const useHomeMatchPreferences = () => {
    const {ENABLED, DISABLED} = HOME_MATCH_SERVICE_NOTIFICATION_CONTENT;

    const [patchHomeMatchPreferences, {isLoading: isHomeMatchPreferencesLoading}] = usePatchUserHomeMatchPreferencesMutation();
    const [putHomeMatchPreferences, {isLoading: isHomeMatchConfigurationLoading}] = usePutUserHomeMatchPreferencesMutation();
    const [patchUserPreferences, {isLoading: isUserPreferencesLoading}] = usePatchUserPreferencesMutation();
    const dispatch = useAppDispatch();
    const siteSource = getSiteSource(useRefererData().slug);

    const switchHomeMatchPreferences = useCallback(
        async (checked: boolean, options: ISwitchHomeMatchPreferencesOptions = {}) => {
            const {
                onPhoneVerificationRequired,
                showSuccessNotification = true,
                syncCplPreferences = true,
                sourceSection,
                skipPhoneVerificationPrompt = false
            } = options;

            try {
                if (sourceSection) {
                    await putHomeMatchPreferences({
                        is_active: checked,
                        source_section: sourceSection
                    }).unwrap();
                } else {
                    await patchHomeMatchPreferences({
                        is_active: checked,
                        update_source: siteSource
                    }).unwrap();
                }

                if (syncCplPreferences) {
                    await patchUserPreferences({
                        [MarketingConsentType.CPL]: checked,
                        update_source: siteSource
                    }).unwrap();
                }

                dispatch(kmApi.util.invalidateTags(["PreleadList"]));

                if (checked || showSuccessNotification) {
                    dispatch(
                        addNotification({
                            type: "success",
                            content: checked ? ENABLED : DISABLED
                        })
                    );
                }

                return true;
            } catch (error) {
                const kmAppError = error as {status?: number; data?: {is_active: string[]}};

                if (checked && isHomeMatchPhoneVerificationRequiredError(kmAppError)) {
                    if (skipPhoneVerificationPrompt) {
                        onPhoneVerificationRequired?.();
                    } else {
                        lscache.remove(PHONE_VERIFICATION_MODAL_DISMISSED);
                        dispatch(
                            requestPhoneVerification({
                                pendingAction: createHmActivationPendingAction(createDefaultHmActivationIntent({syncCplPreferences, sourceSection})),
                                awaitCompletion: true
                            })
                        );
                    }
                } else if (kmAppError?.status === 400 && kmAppError?.data?.is_active) {
                    dispatch(
                        addNotification({
                            type: "failure",
                            content: kmAppError.data.is_active.join(", ")
                        })
                    );
                } else {
                    notifyBugsnagClient(
                        error instanceof Error
                            ? error
                            : {
                                  message: JSON.stringify(error)
                              },
                        "Failed to update HomeMatch and CPL preferences"
                    );
                    dispatch(addNotification(defaultAPIErrorNotification));
                }

                return false;
            }
        },
        [DISABLED, ENABLED, dispatch, patchHomeMatchPreferences, patchUserPreferences, putHomeMatchPreferences, siteSource]
    );

    return {
        isSwitchingHomeMatchPreferences: isHomeMatchPreferencesLoading || isHomeMatchConfigurationLoading || isUserPreferencesLoading,
        switchHomeMatchPreferences
    };
};

const isHomeMatchPhoneVerificationRequiredError = (error: {status?: number; data?: {is_active: string[]}}) => {
    return (
        error?.status === 400 &&
        Array.isArray(error?.data?.is_active) &&
        error.data.is_active.some((message) => message.toLowerCase().includes("zweryfikuj numer telefonu"))
    );
};
